import { render } from "./SurveyTopBar.vue?vue&type=template&id=d8208b36"
import script from "./SurveyTopBar.vue?vue&type=script&lang=js"
export * from "./SurveyTopBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__